module.exports = __webpack_public_path__ + "static/media/vtex20.d021189a.png";